import { resolve as e } from "@scalar/workspace-store/resolve";
import { isArraySchema as t } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/get-enum-values.ts
var n = (n) => {
	if (!n) return [];
	if (n.enum) return n.enum;
	if (t(n) && typeof n.items == "object") {
		let t = e.schema(n.items);
		if (t && "enum" in t && t.enum) return t.enum;
	}
	return [];
};
//#endregion
export { n as getEnumValues };

//# sourceMappingURL=get-enum-values.js.map